<h3 translate class="page-title text-center">DISCOUNT_CODES</h3>
<div class="w-100 text-right">
  <button type="button" class="btn btn-primary" (click)="openDiscountCodeModal()" translate>CREATE</button>
</div>
<lib-filter-list [configService]="discountCodesListConfigService"></lib-filter-list>
